import { supabase } from './supabase';

const ALARM_KEY = 'lifelog_notification_enabled';
const LAST_CHECK_KEY = 'lifelog_notif_last_check';

export function isNotificationEnabled() {
  return localStorage.getItem(ALARM_KEY) === 'true';
}

export async function enableNotifications() {
  if (!('Notification' in window) || !('serviceWorker' in navigator)) {
    alert('이 브라우저에서는 알림을 지원하지 않습니다.');
    return false;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    alert('알림 권한이 거부되었습니다. 브라우저 설정에서 허용해주세요.');
    return false;
  }

  // 서비스워커 등록
  await navigator.serviceWorker.register('/sw.js');
  localStorage.setItem(ALARM_KEY, 'true');
  return true;
}

export function disableNotifications() {
  localStorage.setItem(ALARM_KEY, 'false');
}

// 앱 열릴 때 호출 — 하루 1회 과거 기록 확인 후 알림
export async function checkAndNotify(userId) {
  if (!isNotificationEnabled()) return;
  if (Notification.permission !== 'granted') return;

  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem(LAST_CHECK_KEY) === today) return;
  localStorage.setItem(LAST_CHECK_KEY, today);

  const mm = today.slice(5, 7);
  const dd = today.slice(8, 10);

  // 오늘과 월/일이 같은 과거 기록 조회
  const { data } = await supabase
    .from('records')
    .select('title, start_date')
    .eq('user_id', userId);

  if (!data) return;

  const matches = data.filter((r) => {
    if (!r.start_date) return false;
    return r.start_date.slice(5, 7) === mm &&
           r.start_date.slice(8, 10) === dd &&
           r.start_date.slice(0, 4) !== today.slice(0, 4);
  });

  if (matches.length === 0) return;

  const record = matches[Math.floor(Math.random() * matches.length)];
  const year = record.start_date.slice(0, 4);
  const yearsAgo = parseInt(today.slice(0, 4)) - parseInt(year);

  const reg = await navigator.serviceWorker.ready;
  reg.showNotification('인생로그', {
    body: `📖 ${yearsAgo}년 전 오늘, "${record.title}" 기록을 했어요!`,
    icon: '/logo192.png',
    tag: 'lifelog-memory',
  });
}
